/**
 * @fileoverview Sales query refresh hook.
 * @description Returns a function that marks every sales query stale — the backend Sales CRM
 * queries and the mock-only tenant, target and roster ones. Sales Pipeline calls it after a
 * mock-only row action (edit, archive, Assign Target, …), whose own mutation only refreshes the
 * mock model, so the backlog read from the Sales CRM endpoints reflects the change too.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQueryClient } from '@tanstack/react-query'

import { SALES_QUERY_KEY } from '@/features/sales/constants/prospects-query-keys.constants'

/**
 * @description Builds the refresh function.
 * @returns {() => void} Marks every sales query stale, refetching the ones on screen.
 */
export function useRefreshSalesQueries(): () => void {
  const queryClient = useQueryClient()
  return () => {
    void queryClient.invalidateQueries({ queryKey: SALES_QUERY_KEY })
  }
}
